// This is required because in static pages the app redux's device is not built
// using ./get-initial-device-state
export const initialIsMainLiveCDN = process.env.SERVER_URL === 'https://bridebook.co.uk/';
